// src/utils/notificationUtils.js
import { getToken, onMessage } from "firebase/messaging";
import { doc, updateDoc } from "firebase/firestore";
import { messaging, db } from "../firebase";

// REPLACE WITH YOUR VAPID KEY FROM FIREBASE CONSOLE (Project Settings -> Cloud Messaging -> Web configuration)
const VAPID_KEY = "PLEASE_ADD_YOUR_VAPID_KEY_HERE";

export const requestNotificationPermissionAndSaveToken = async (userId) => {
    try {
        const permission = await Notification.requestPermission();
        if (permission === 'granted') {
            console.log('Notification permission granted.');

            const messagingInstance = await messaging();
            if (!messagingInstance) {
                console.warn('Messaging is not supported on this browser context.');
                return null;
            }

            const currentToken = await getToken(messagingInstance, { vapidKey: VAPID_KEY });

            if (currentToken) {
                console.log('FCM Token generated:', currentToken);
                // Save the token to the user's document in Firestore
                const userRef = doc(db, 'users', userId);
                await updateDoc(userRef, { fcmToken: currentToken });
                return currentToken;
            } else {
                console.warn('No registration token available. Request permission to generate one.');
            }
        } else {
            console.warn('Notification permission denied or ignored.');
        }
    } catch (error) {
        console.error('An error occurred while retrieving token or updating document:', error);
    }
    return null;
};

export const removeNotificationToken = async (userId) => {
    try {
        const userRef = doc(db, 'users', userId);
        await updateDoc(userRef, { fcmToken: null });
        console.log('FCM token removed from user settings.');
    } catch (error) {
        console.error('An error occurred while removing FCM token:', error);
    }
};

export const onMessageListener = async () => {
    const messagingInstance = await messaging();
    if (!messagingInstance) return null;

    return new Promise((resolve) => {
        onMessage(messagingInstance, (payload) => {
            resolve(payload);
        });
    });
};
